/**
 * i18n «Мои обращения» агента (DEV-438, фаза 2 DEV-332).
 *
 * Подмешивается в основные локали через deep-merge в ./index.ts (как
 * agentTickets / agentsAdmin). Расширяет блок agents.* (пункт меню
 * home.menu.myInquiries + раздел inquiries.*). Интерполяция {date} — штатная
 * (vue-i18n named param), литеральных фигурных скобок нет.
 */

type LocaleOverride = Record<string, unknown>

export const agentInquiriesMessages: Record<'ru' | 'en' | 'vn', LocaleOverride> = {
  ru: {
    agents: {
      home: {
        menu: {
          myInquiries: {
            title: 'Мои обращения',
            subtitle: 'Статусы и переписка по вашим вопросам',
          },
        },
      },
      inquiries: {
        back: 'На главную',
        title: 'Мои обращения',
        subtitle: 'Ваши вопросы менеджеру и ответы по ним',
        error: {
          title: 'Не удалось загрузить',
          retry: 'Повторить',
        },
        empty: {
          title: 'Обращений пока нет',
          description: 'Здесь появятся ваши вопросы менеджеру и ответы на них.',
        },
        status: {
          new: 'Новое',
          in_progress: 'В работе',
          closed: 'Закрыто',
        },
        type: {
          commission_question: 'Вопрос по вознаграждению',
          meeting_request: 'Запрос на встречу',
          partnership: 'Партнёрство',
          strategy_question: 'Вопрос по стратегии',
          client_registration: 'Регистрация клиента',
          other: 'Другой вопрос',
        },
        card: {
          created: 'Создано {date}',
        },
        thread: {
          back: 'К списку',
          loading: 'Загрузка…',
          noMessages: 'Сообщений пока нет.',
          closed: 'Обращение закрыто.',
          author: {
            agent: 'Вы',
            staff: 'Менеджер',
          },
          reply: {
            placeholder: 'Напишите сообщение…',
            send: 'Отправить',
            error: 'Не удалось отправить сообщение',
          },
        },
      },
    },
  },
  en: {
    agents: {
      home: {
        menu: {
          myInquiries: {
            title: 'My inquiries',
            subtitle: 'Statuses and conversation on your questions',
          },
        },
      },
      inquiries: {
        back: 'Home',
        title: 'My inquiries',
        subtitle: 'Your questions to the manager and their replies',
        error: {
          title: 'Could not load',
          retry: 'Retry',
        },
        empty: {
          title: 'No inquiries yet',
          description: 'Your questions to the manager and their replies will appear here.',
        },
        status: {
          new: 'New',
          in_progress: 'In progress',
          closed: 'Closed',
        },
        type: {
          commission_question: 'Commission question',
          meeting_request: 'Meeting request',
          partnership: 'Partnership',
          strategy_question: 'Strategy question',
          client_registration: 'Client registration',
          other: 'Other question',
        },
        card: {
          created: 'Created {date}',
        },
        thread: {
          back: 'Back to list',
          loading: 'Loading…',
          noMessages: 'No messages yet.',
          closed: 'The inquiry is closed.',
          author: {
            agent: 'You',
            staff: 'Manager',
          },
          reply: {
            placeholder: 'Write a message…',
            send: 'Send',
            error: 'Could not send the message',
          },
        },
      },
    },
  },
  vn: {
    agents: {
      home: {
        menu: {
          myInquiries: {
            title: 'Yêu cầu của tôi',
            subtitle: 'Trạng thái và hội thoại cho câu hỏi của bạn',
          },
        },
      },
      inquiries: {
        back: 'Trang chủ',
        title: 'Yêu cầu của tôi',
        subtitle: 'Câu hỏi của bạn gửi quản lý và phản hồi',
        error: {
          title: 'Không thể tải',
          retry: 'Thử lại',
        },
        empty: {
          title: 'Chưa có yêu cầu',
          description: 'Câu hỏi của bạn gửi quản lý và phản hồi sẽ hiển thị ở đây.',
        },
        status: {
          new: 'Mới',
          in_progress: 'Đang xử lý',
          closed: 'Đã đóng',
        },
        type: {
          commission_question: 'Hỏi về hoa hồng',
          meeting_request: 'Yêu cầu cuộc hẹn',
          partnership: 'Hợp tác',
          strategy_question: 'Hỏi về chiến lược',
          client_registration: 'Đăng ký khách hàng',
          other: 'Câu hỏi khác',
        },
        card: {
          created: 'Tạo lúc {date}',
        },
        thread: {
          back: 'Về danh sách',
          loading: 'Đang tải…',
          noMessages: 'Chưa có tin nhắn.',
          closed: 'Yêu cầu đã đóng.',
          author: {
            agent: 'Bạn',
            staff: 'Quản lý',
          },
          reply: {
            placeholder: 'Viết tin nhắn…',
            send: 'Gửi',
            error: 'Không thể gửi tin nhắn',
          },
        },
      },
    },
  },
}
